import { defineStore } from 'pinia'
import { store } from '@/store'
import { MusicOriginType } from '@/types/constantsEnum'
export interface Song {
  id: string
  title: string
  artist?: string
  url: string
  cover?: string
  duration?: number
  lycris?: string
  voiceClone?: {
    name?: string
  }
}

export const useMusicPlayerStore = defineStore({
  id: 'musicPlayer',
  state: () => ({
    // 播放状态
    isPlaying: false,
    currentSongIndex: null as number | null,
    isFullscreen: false,
    isVisible: false,
    playlist: [] as Song[],
    isLoading: false, // 音频加载状态

    // 音频控制相关
    currentTime: 0, // 当前播放时间
    duration: 0, // 总时长
    volume: 100, // 音量
    isMuted: false, // 是否静音
    audioProgress: 0, // 音频进度
    drawerVisibleList: false, // 音乐列表
    originType: null as MusicOriginType | null, // 音乐来源类型
  }),
  actions: {
    // 切换播放状态
    togglePlay(isPlay?: boolean) {
      this.isPlaying = isPlay ?? !this.isPlaying
    },

    // 设置当前播放歌曲索引
    setCurrentSongIndex(index: number | null) {
      this.isPlaying = false
      this.currentSongIndex = index
    },

    // 切换全屏状态
    toggleFullscreen(isFullscreen?: boolean) {
      this.isFullscreen = isFullscreen ?? !this.isFullscreen
    },

    // 设置播放列表
    setPlaylist(songs: Song[]) {
      this.resetPlayer()
      this.playlist = songs
      this.currentSongIndex = 0
    },
    setPlaylistDuration(index: number, duration: string) {
      this.playlist[index].duration = duration
    },
    // 隐藏播放器
    hidePlayer() {
      this.isVisible = false
    },

    // 显示播放器
    showPlayer() {
      this.isVisible = true
    },

    // 播放下一首
    playNext() {
      if (this.currentSongIndex === null || this.playlist.length === 0) return
      const nextIndex = (this.currentSongIndex + 1) % this.playlist.length
      this.isPlaying = false
      this.currentSongIndex = nextIndex
      this.isPlaying = true
    },

    // 播放上一首
    playPrevious() {
      if (this.currentSongIndex === null || this.playlist.length === 0) return
      const prevIndex = (this.currentSongIndex - 1 + this.playlist.length) % this.playlist.length
      this.isPlaying = false
      this.currentSongIndex = prevIndex
      this.isPlaying = true
    },

    // 更新播放进度
    updateProgress(time: number, totalDuration: number) {
      this.currentTime = time
      this.duration = totalDuration
      this.audioProgress = (time / totalDuration) * 100 || 0
    },

    // 设置音量
    setVolume(newVolume: number) {
      this.volume = newVolume
    },

    // 切换静音状态
    toggleMute() {
      this.isMuted = !this.isMuted
    },

    // 跳转到指定时间
    seekTo(time: number) {
      this.currentTime = time
    },
    closeDrawerList() {
      this.drawerVisibleList = false
    },
    openDrawerList() {
      this.drawerVisibleList = true
    },
    toggleDrawerList() {
      this.drawerVisibleList = !this.drawerVisibleList
      console.log('toggleDrawerList', this.drawerVisibleList)
    },
    // 重置播放器
    resetPlayer() {
      this.playlist = []
      this.isPlaying = false
      this.currentSongIndex = null
      this.currentTime = 0
      this.duration = 0
      this.audioProgress = 0
    },
    playing() {
      this.isPlaying = true
    },
    pause() {
      this.isPlaying = false
    },
    // 设置音乐来源类型
    setOriginType(originType: MusicOriginType) {
      this.originType = originType
    },
    // 设置加载状态
    setLoading(status: boolean) {
      this.isLoading = status
    },
  },
})

export function useMusicPlayerStoreHook() {
  return useMusicPlayerStore(store)
}
